export const POLL_INTERVALS = {
  dashboard: 3 * 60_000,
  serviceCalls: 5 * 60_000,
  notificationsUnread: 2 * 60_000,
};

export const CACHE_TTLS = {
  dashboard: 3 * 60_000,
  employeeDashboard: 3 * 60_000,
  crmDashboard: 3 * 60_000,
  adminOverview: 3 * 60_000,
  tasks: 2 * 60_000,
  taskSummary: 2 * 60_000,
  taskAssignees: 15 * 60_000,
  expenses: 5 * 60_000,
  purchaseOrders: 5 * 60_000,
  poCoordinators: 15 * 60_000,
  poFinanceApprovers: 15 * 60_000,
  serviceCalls: 5 * 60_000,
  crm: 5 * 60_000,
  crmFollowUps: 5 * 60_000,
  documents: 5 * 60_000,
  users: 15 * 60_000,
  departments: 15 * 60_000,
  notificationsUnread: 2 * 60_000,
  reports: 5 * 60_000,
};
